import { getClients } from "../../../../api/clients";
export const clientOrderCount = (row) =>
  row.orderCount != null &&
  row.orderCount !== "" &&
  Number.isInteger(Number(row.orderCount)) &&
  Number(row.orderCount) >= 0
    ? Number(row.orderCount)
    : null;
export const getClientList = async () => {
  const response = await getClients();
  if (response?.error !== false || !Array.isArray(response.data))
    return { error: true };
  return {
    ...response,
    data: response.data.map((row) => ({
      ...row,
      name: row.fullname?.trim() || "Sin nombre",
    })),
  };
};
